var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCasenoteshistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66797 17.8737C3.66797 17.2659 3.90941 16.683 4.33918 16.2532C4.76895 15.8235 5.35185 15.582 5.95964 15.582H18.3346M3.66797 17.8737C3.66797 18.4815 3.90941 19.0644 4.33918 19.4942C4.76895 19.9239 5.35185 20.1654 5.95964 20.1654H18.3346V1.83203H5.95964C5.35185 1.83203 4.76895 2.07347 4.33918 2.50324C3.90941 2.93302 3.66797 3.51591 3.66797 4.1237V17.8737Z",
    stroke: "#8C198F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCasenoteshistory);
export default __webpack_public_path__ + "static/media/casenoteshistory.cdc446dc26412dc4af37589464ed4cf0.svg";
export { ForwardRef as ReactComponent };